import React, { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { getDocByType, getMainPageByUid } from 'helpers/PrismicKnowledgeHub';
import { globalPropsRequests } from 'utils/globalProps';
import Loader from 'components/Loader';
import Error from 'components/Error';
import { StorefrontContext } from 'providers/storefront';
import { handleResetSearch } from 'helpers/searchReset';
import KnowledgeHubHeader from 'components/NewKnowledgeHub/KnowledgeHubHeader';
import Copyright from 'containers/Layout/Footer/Copyright';
import Script from 'next/script';
import TopicsList from 'components/NewKnowledgeHub/TopicsList';
import FeaturedSectionList from 'components/NewKnowledgeHub/FeaturedSectionList';
import Head from 'next/head';

function KnowledgeHubPage({ content }) {
  const { setFilteredResults, setSearchInput } = useContext(StorefrontContext);
  const [viewMore, setViewMore] = useState(false);
  const { isFallback } = useRouter();
  if (isFallback) {
    return <Loader />;
  }

  const seoTitle = content?.main?.seo_title;
  const seoDescription = content?.main?.seo_description;
  const ogImage = content?.main?.og_image;
  const ogDescription = content?.main?.og_description;

  const router = useRouter();
  const isNotMainPage = router.asPath.split('/').length > 2;

  if (!content) {
    return <Error code={404} />;
  }

  const topics = content.topics;
  const description = content.main.description;

  // console.log('main ==> ', content.main);
  // console.log('topics =>> ', topics);
  // console.log('discussions =>> ', content.discussions);
  // console.log('posts ==>> ', content.posts);

  const toggleViewMore = () => {
    setViewMore(true);
  };

  return content ? (
    <>
      <Head>
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta property="og:description" content={ogDescription} />
        <meta
          property="og:image"
          content={
            ogImage?.url
              ? ogImage?.url
              : 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/ogImage.png?v=1713964496'
          }
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1024" />
      </Head>
      <Script
        src="https://static.cdn.prismic.io/prismic.js?new=true&repo=aftershock-knowledge-hub"
        strategy="lazyOnload"
      />
      <div className="body-wrapper">
        <KnowledgeHubHeader
          isNotMainPage={isNotMainPage}
          description={description}
        />
        <div
          className="container"
          onClick={() => handleResetSearch(setFilteredResults, setSearchInput)}
        >
          <div className="content-wrapper">
            <div className="background-color-wrapper">
              <div className="content-section">
                <div className="topics-wrapper">
                  <h2 className="topics-title">Popular Topics</h2>
                  <TopicsList topics={topics} viewMore={viewMore} />
                  {!viewMore && (
                    <span className="view-more-button" onClick={toggleViewMore}>
                      View More
                    </span>
                  )}
                </div>
                <FeaturedSectionList
                  posts={content.posts}
                  discussions={content.discussions}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-wrapper">
          <Copyright />
        </div>
      </div>
      <style jsx>{`
        .body-wrapper {
          display: grid;
          grid-template-rows: auto 1fr auto;
          min-height: 100vh;
        }
        .content-wrapper {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background-color: #141414;
        }
        .background-color-wrapper {
          display: flex;
          justify-content: center;
          align-items-center;
          margin-top: -25px;
          width: 100%;
          background-color: #1e1e1e;
        }
        @media (max-width: 767px) {
          .background-color-wrapper {
            margin-top: 30px;
          }
        }
        .content-section {
          padding-top: 40px;
          width: 100%;
          max-width: 1440px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
        }
        .topics-wrapper {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
        }
        @media (max-width: 767px) {
          .content-section {
            padding: 0;
          }
        }
        .topics-title {
          width: 100%;
          text-align: center;
          font-family: 'Roboto-Medium';
          font-size: 20px;
          font-weight: 600;
        }
        @media (max-width: 767px) {
          .topics-title {
            text-align: left;
            font-size: 16px;
            font-weight: 600;
          }
          .topics-wrapper {
            align-items: center;
          }
        }  
        @media (min-width: 426px) {
          .topics-wrapper {
            align-items: center;
          }
          .topics-title {
            text-align: center
          }
        }      
        @media (max-width: 425px) {
          .topics-wrapper {
            align-items: center;
          }
          .topics-title {
            padding: 0 48px;
          }
        }
        @media (max-width: 375px) {
          .topics-title {
            padding: 0 32px;
          }
        }       
        @media (max-width: 320px) {
          .topics-title {
            padding: 0 5px;
          }
        }    
        .view-more-button {
          display: none;
        }
        @media (max-width: 767px) {
          .view-more-button {
            width: 100%;
            margin: 10px 0;
            display: block;
            font-family: 'Roboto-Normal';
            font-size: 10px;
            text-decoration: underline;
            color: #950810;
            text-align: center;
          }
        } 
        @media (max-width: 425px) {
          .view-more-button {
            text-align: right;
            padding-right: 50px;
          }
        }       
        @media (max-width: 375px) {
          .view-more-button {
            text-align: right;
            padding-right: 32px;
          }
        }       
        @media (max-width: 320px) {
          .view-more-button {
            text-align: right;
            padding-right: 5px;
          }
        }
      `}</style>
    </>
  ) : (
    <div>Data not found</div>
  );
}

export async function getStaticProps({ preview = false, previewData }) {
  const ref = previewData?.ref || null;
  const global = {};

  await Promise.all(globalPropsRequests)
    .then((responses) => {
      responses.forEach((res) => {
        if (res) {
          const [id, body] = res;
          global[id] = body.data;
        }
      });
    })
    .catch(() => null);

  const mainPage = await getMainPageByUid(ref);
  const topics = await getDocByType('topic', { ref });
  const discussions = await getDocByType('discussion', { ref });
  const posts = await getDocByType('post', { ref });

  const results = {
    main: mainPage?.data || null,
    topics: topics || null,
    discussions: discussions || null,
    posts: posts || null,
  };

  return {
    props: {
      content: results,
      global,
      preview,
    },
    revalidate: 3600,
  };
}

export default KnowledgeHubPage;
